// test844
(844 && 0);
